const wysiwygDecorators = {
    link: 'link',
    script: 'subscript'
};

export default wysiwygDecorators;
